import TagManager from 'react-gtm-module'

export const initGtm = () => {
	const options = {
		gtmId: 'GTM-T3LJ5SJ'
	}
	TagManager.initialize(options)
}

export const handlePageView = location => {
	if (localStorage.getItem('areCookiesAgreed') === "true") {
		window.dataLayer.push({
			event: 'pageview',
			page: {
				url: location.href
			}
		})
	}
}